module.exports = __webpack_public_path__ + "img/reporting-image.9a101f3a.png";